import { useMutation } from '@app/QueryClient';

import apiCheckResetToken from '@app/Services/ForgotPassword/checkResetToken';
import { ETokensStatusCode } from '@app/ForgotPassword/components/CheckResetToken';
import { parseError } from '@app/QueryClient/parseError';

export default function useCheckResetToken(opt: {
	onError: (rawError: {
		message?: string | undefined;
		statusCode: number;
	}) => void;
	onSuccess: () => void;
	disableToaster?: boolean;
}) {
	const mutation = useMutation(apiCheckResetToken, {
		onSuccess: () => {
			opt?.onSuccess?.();
		},
		onError: async (error?: { response?: { status: number } }) => {
			const statusCode =
				error?.response?.status || ETokensStatusCode.INVALID_LINK;
			const parsedError = await parseError(error);
			opt?.onError?.({ ...parsedError, statusCode });
		},
		disableToaster: true,
	});

	const { mutate } = mutation;

	return {
		...mutation,
		doCheckResetToken: mutate,
	};
}
